import { css } from '@/styled-system/css';

export const autocompleteContainerStyles = css.raw({
  position: 'relative',
  width: '100%',
  paddingBottom: '200',
  md: {
    flex: 1,
    marginRight: '400',
    paddingBottom: '0',
  },
});

export const dropdownStyles = css.raw({
  position: 'absolute',
  width: '100%',
  maxWidth: '100vw',
  zIndex: 'dropdown',
  maxHeight: '100vh',
  borderRadius: '0 0 {radii.100} {radii.100}',
  marginTop: '{spacing.-50}',
  // oxlint-disable-next-line constellation/prefer-semantic-tokens -- ESLint's pandaLint set this warn-only; oxlint's oxlintPandaLint sets it error, no code change
  paddingTop: '{spacing.50}',
  border: '1px solid {colors.border.subtle}',
  borderTop: 'none',
  textAlign: 'left',
});

export const dropdownItemStyles = css.raw({
  paddingBlock: 0,
  paddingInline: { base: '400', md: '600' },
  backgroundColor: 'bg.neutral',
  cursor: 'pointer',
  '& :last-of-type': {
    borderRadius: '0 0 {radii.100} {radii.100}',
  },
  '& :last-of-type > *': {
    borderBottom: 'none',
  },
});

export const dropdownItemTextStyles = css.raw({
  width: '100%',
  height: { base: '1200', md: '1400' },
  lineHeight: { base: '1100', md: '1400' },
  borderBottom: '1px solid {colors.border.subtle}',
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
});
